export function isRepeat(value) {
    return [
        'repeat',
        'repeat-x',
        'repeat-y',
        'no-repeat',
        'initial',
        'inherit'
    ].includes(value);
}
//# sourceMappingURL=repeat.js.map